import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { KeyRound } from "lucide-react";
import client from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// Header-mounted Vault progress badge.
// Only renders when:
//   - user is signed in
//   - they have collected at least one codebreaker letter (we don't want to
//     surface the Vault to brand-new visitors — discovery is the whole point)
//   - they have NOT yet solved the codebreaker
// Click → /the-vault where the collected letters are already pre-loaded.
export default function VaultProgressBadge() {
  const { user } = useAuth();
  const [state, setState] = useState(null);

  useEffect(() => {
    if (!user) { setState(null); return; }
    let alive = true;
    client.get("/codebreaker/state")
      .then((r) => { if (alive) setState(r.data); })
      .catch(() => { if (alive) setState(null); });
    return () => { alive = false; };
  }, [user]);

  if (!user || !state) return null;
  const collected = Number(state.fragments_collected_count || 0);
  const total = Number(state.fragments_total || 6);
  if (collected <= 0) return null;
  if (state.solved) return null;

  return (
    <Link
      to="/the-vault"
      data-testid="vault-progress-badge"
      title={`Vault progress · ${collected}/${total} letters found — tap to arrange`}
      className="hidden lg:inline-flex items-center gap-1.5 px-2.5 py-1.5 border border-[#FF3B30]/60 bg-[#FF3B30]/10 hover:bg-[#FF3B30] hover:text-white text-[#FF3B30] transition-colors label-eyebrow text-[10px]"
    >
      <KeyRound size={11} strokeWidth={2} />
      <span>Vault {collected}/{total}</span>
    </Link>
  );
}
